import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { Field } from 'redux-form';
import { useToggle } from '../../../../../infra/small-tools/use-toggle';
import { PayoutsCard } from './payouts-card';
import { SelectPayoutModalContainer as SelectPayoutModal } from './select-payout-modal.container';
var PayoutCardComponent = function (_a) {
    var input = _a.input, meta = _a.meta, barberName = _a.barberName;
    var selectPayoutModal = useToggle(false);
    var handleSetUpPayout = function () {
        selectPayoutModal.setOn();
    };
    var getPayoutMethodFromInputValue = function () {
        if (input.value) {
            return 'auto';
        }
        if (input.value === false) {
            return 'manual';
        }
        return null;
    };
    var getInputValueFromPayoutMethod = function (payoutMethod) {
        return payoutMethod === 'auto';
    };
    var handleChangePayoutMethod = function (payoutMethod) {
        input.onChange(getInputValueFromPayoutMethod(payoutMethod));
    };
    return (_jsxs(_Fragment, { children: [_jsx(PayoutsCard, { onSetUpPayout: handleSetUpPayout, hasError: meta.touched && !!meta.error, payoutMethod: getPayoutMethodFromInputValue() }), _jsx(SelectPayoutModal, { barberName: barberName, isOpen: selectPayoutModal.isOn, onClose: selectPayoutModal.setOff, selectedPayoutMethod: getPayoutMethodFromInputValue(), onSelectPayoutMethod: handleChangePayoutMethod })] }));
};
export var PayoutsCardContainer = function (_a) {
    var barberName = _a.barberName;
    return (_jsx(Field, { name: "depositSettings.enabled", component: PayoutCardComponent, barberName: barberName }));
};
